


/* eslint-disable react/jsx-pascal-case */
import { Button, Col, ConfigProvider, Form, Row, Modal, Popover } from "antd";
import React, { useEffect, useState } from "react";


const ConfirmPopover = (
    {
        title = "",
        content,
        buttonContent = "",
        onOk = () => {

        },
        size = "small",
        buttonType = "primary",
        buttonStyle = {

        }
    }
) => {
    const [open, setOpen] = useState(false)
    return (
        <>
            <Popover
                content={<>
                    <Row>
                        {content}
                    </Row>
                    <Row
                        justify={"end"}
                        style={{
                            padding: 5
                        }}
                    >
                        <Col
                            style={{ paddingInline: 2 }}
                        >
                            <Button
                                onClick={() => setOpen(false)}
                                size="small"
                            >
                                取消
                            </Button>
                        </Col>
                        <Col
                            style={{ paddingInline: 2 }}
                        >
                            <Button
                                type='primary'
                                onClick={() => { onOk(); setOpen(false) }}
                                size="small"
                            >
                                確認
                            </Button>
                        </Col>
                    </Row>
                </>}
                title={title}
                open={open}
                trigger="click"
            >
                <Button
                    style={{
                        ...buttonStyle,
                    }}
                    type={buttonType}
                    onClick={() => setOpen(true)}
                    size={size}
                >
                    {buttonContent}
                </Button>
            </Popover >
        </>
    )
}


export default ConfirmPopover;
